export default __webpack_public_path__ + "static/media/exploded-view_labels.45f9f88d.png";